let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1aM3u")).then(() => parcelRequire('6uevy'));